/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I mix different units?`)
};

const es_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo combinar diferentes unidades?`)
};

const de_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich unterschiedliche Einheiten mischen?`)
};

const nl_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik verschillende eenheden combineren?`)
};

const fr_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je mélanger différentes unités ?`)
};

const it_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso combinare unità diverse?`)
};

const pt_br2_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso misturar unidades diferentes?`)
};

const pt_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso misturar unidades diferentes?`)
};

const ja_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`異なる単位を混在させることはできますか？`)
};

const zh_soldil_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以混用不同单位吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_q2", locale)
	if (locale === "en") return en_soldil_faq_q2(inputs)
	if (locale === "es") return es_soldil_faq_q2(inputs)
	if (locale === "de") return de_soldil_faq_q2(inputs)
	if (locale === "nl") return nl_soldil_faq_q2(inputs)
	if (locale === "fr") return fr_soldil_faq_q2(inputs)
	if (locale === "it") return it_soldil_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_q2(inputs)
	if (locale === "pt") return pt_soldil_faq_q2(inputs)
	if (locale === "ja") return ja_soldil_faq_q2(inputs)
	return zh_soldil_faq_q2(inputs)
};